<script>
import { envApi, userApi } from '@/apis'

const getKey = async (keys) => {
    const { body } = await envApi.envsGet({
        params: {
            key: keys
        }
    })
    return body
}

const getSchools = async () => {
    const { body } = await userApi.schoolsGet()
    console.log(body)
    return body
}

export default {
    getConfig: (keys) => getKey(keys),
    getSchools: () =>  getSchools()
}
</script>